import { useEffect, useRef, useState } from "react";
import { Globe, Check } from "lucide-react";
import { LANGS, setLang, useLang } from "../i18n";
import { api, getToken } from "../lib/api";

export function LangButton({ className = "" }) {
  const lng = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const close = (e) => { if (!ref.current?.contains(e.target)) setOpen(false); };
    document.addEventListener("pointerdown", close);
    return () => document.removeEventListener("pointerdown", close);
  }, [open]);

  const pick = (code) => {
    setLang(code);
    setOpen(false);
    if (getToken()) api.put("/auth/settings", { idioma: code }).catch(() => {});
    else localStorage.setItem("circulo_lang_pending", code);
  };

  return (
    <div ref={ref} className={`relative ${className}`}>
      <button type="button" data-testid="lang-btn" onClick={() => setOpen((o) => !o)} aria-label="Language"
        className="flex items-center gap-1 rounded-full border border-border px-2.5 py-1.5 text-xs font-medium text-muted-foreground hover:text-foreground hover:bg-secondary transition-colors">
        <Globe size={14} /> <span data-testid="lang-current">{lng.toUpperCase()}</span>
      </button>
      {open && (
        <ul data-testid="lang-menu" className="absolute right-0 mt-2 w-44 surface p-1 shadow-xl z-[60]">
          {LANGS.map((l) => (
            <li key={l.code}>
              <button type="button" data-testid={`lang-option-${l.code}`} onClick={() => pick(l.code)}
                className={`w-full flex items-center gap-2 rounded-lg px-3 py-2 text-sm text-left hover:bg-secondary ${l.code === lng ? "text-[#f3c649]" : ""}`}>
                <span className="text-base leading-none">{l.flag}</span> <span className="flex-1">{l.label}</span>
                {l.code === lng && <Check size={14} />}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
